import React, { createContext, useContext, useEffect, useState } from "react";
import { io } from "socket.io-client";

const SocketContext = createContext(null);

export const useSocket = () => useContext(SocketContext);

const Endpoint =
  process.env.REACT_APP_SOCKET_BACKEND_URL || "https://looknatest.com/backend";

export const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);
  const [socketConnected, setSocketConnected] = useState(false);

  useEffect(() => {
    const userId = localStorage.getItem("userId");
    const socketInstance = io(Endpoint, {
      query: { userID: userId },
    });
    setSocket(socketInstance);

    socketInstance.on("connected", () => setSocketConnected(true));
    socketInstance.emit("setup", userId);

    // const interval = setInterval(() => {
    //   socketInstance.emit("notifications-req", userId);
    // }, 3000);

    // socketInstance.on("notification-req", (message) => {
    //   console.log(message, "---------");
    // });

    return () => {
      if (socketInstance.connected) {
        socketInstance.emit("manual-disconnect", userId);
      }
      socketInstance.disconnect();
    };
  }, []);

  return (
    <SocketContext.Provider value={{ socket, socketConnected }}>
      {children}
    </SocketContext.Provider>
  );
};
